import * as React from "react"

import Home from "../components/update"
import Seo from "../components/seo"

const SsgPage = () => (
<Home>
<Seo title="Static site generator website development jekyll eleventy astro" />


<div className="container">
<div className="row mt-5">
<div className="col-md-6 p-3 p-md-5 mt-5 mb-5">
<h1><strong><a href="/ssg/">Static Site Generator</a></strong></h1>
<h2>Static site generator website development jekyll eleventy astro.</h2>
<p>Selamat datang di era website cepat , dan menggunakan static site generator adalah soluti tepat dalam kebutuhan untuk membuat dan mengembangkan website cepat dan penuh SEO di dalam nya, dan kini pun banyak website yang beralih menggunakan nya untuk kebutuhan pengembangan situs modern , dan kita dapat menggunakan dukungan berbagai tech untuk di terapkan mulai dari jekyll ruby on rails, atau bekerja dengan node js via <a href="https://www.11ty.dev/">eleventy 11ty</a> dan astro.</p>
<ul className="nav nav-pills mb-3" id="pills-tab">
  <li className="nav-item p-1" role="presentation">
    <button className="btn btn-dark btn-sm active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Demo 1</button>
  </li>
  <li className="nav-item p-1" role="presentation">
    <button className="btn btn-dark btn-sm" id="pills-demokasir-tab" data-bs-toggle="pill" data-bs-target="#pills-demokasir" type="button" role="tab" aria-controls="pills-demokasir" aria-selected="false">Demo 2</button>
  </li>
  <li className="nav-item p-1" role="presentation">
    <button className="btn btn-dark btn-sm" id="pills-hotel-tab" data-bs-toggle="pill" data-bs-target="#pills-hotel" type="button" role="tab" aria-controls="pills-hotel" aria-selected="false">Demo 3</button>
  </li>
 
</ul>
</div>
<div className="col-md-6 p-3 p-md-5 mt-5 mb-5">

<div className="tab-content" id="pills-tabContent">
  <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
<div className="ratio ratio-16x9">
  <iframe width="560" height="315" className="rounded" src="https://www.youtube.com/embed/kdSd8J1b9O4" title="Pembuatan website terbaru static site generator"></iframe>
</div>
  </div>
  <div className="tab-pane fade" id="pills-demokasir" role="tabpanel" aria-labelledby="pills-demokasir-tab">
  <div className="ratio ratio-16x9">
  <iframe width="560" height="315" className="rounded" src="https://www.youtube.com/embed/tOVfVBucd58" title="Pembuatan website eleventy 11ty static site generator"></iframe>
</div>
  </div>
  <div className="tab-pane fade" id="pills-hotel" role="tabpanel" aria-labelledby="pills-hotel-tab">
  <div className="ratio ratio-16x9">
  <iframe width="560" height="315" className="rounded" src="https://www.youtube.com/embed/ntH23D1kjbY" title="Pembuatan website jekyll astro"></iframe>
</div>
  </div>

  </div>
  

</div>

</div>
</div>

</Home>
)

export default SsgPage